import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import RangeSliderViewModelType from '@/ViewModels/Controls/RangeSliderViewModel';

export default class RangeSlider extends Control {

    private jQueryControl: JQuery;

    /**
     * @override
     */
    public widget: KnockoutObservable<kendo.ui.RangeSlider>;

    public constructor(private viewModel: RangeSliderViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div></div>');

        this.applyBindings(this.jQueryControl, {
            kendoRangeSlider: {
                enabled: this.viewModel.isEnabled,

                values: this.viewModel.values,

                min: this.viewModel.min,

                max: this.viewModel.max,

                largeStep: this.viewModel.largeStep,

                smallStep: this.viewModel.smallStep,

                tooltip: this.viewModel.kTooltip,

                tickPlacement: this.viewModel.tickPlacement,

                widget: this.widget
            }
        });

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: kendo.ui.RangeSlider): void {
        this.applyBindings(this.jQueryControl.closest('.k-widget'), {
            controlName: 'rangeslider',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.markers != null) {
            let ticks = this.jQueryControl.closest('.k-widget').find('.k-slider-items .k-tick').html('&nbsp;');

            for (let i = 0; i < this.viewModel.markers.length; i++) {
                let marker = this.viewModel.markers[i];
                let tickRef = ticks.filter('[title="' + marker.titleRef + '"]');

                tickRef.append('<div class="c-marker">' + marker.title + '</div>');
            }
        }

        this.async(() => {
            widget.trigger('resize');
        });
    }
}

ComponentManager.setControl('RangeSlider', RangeSlider, 'RADPresentation.HTMLClient.DefaultViewExtensions');